import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing050({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010201.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010202.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010203.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010204.gif`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010205.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/050/25010206.jpg`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton3.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing050;
